/**
 * "1 exam" / "3 exams"; pass `many` for irregular words ("city" → "cities") and
 * `shown` to print a formatted count ("1,204 students").
 */
export const plural = (n: number, one: string, many = `${one}s`, shown: string | number = n): string =>
  `${shown} ${n === 1 ? one : many}`;
